<div class="login-footer d-flex">
    <div *ngIf="showSnowGlobe"><img src="./assets/img/snow-globe.png" id="snow-globe" class="img-fluid snow-globe" alt="Make it snow!" title="Make it snow!" [ngClass]="{'explode':explodeSnowGlobe}" (click)="emitClick($event)" /></div>
    <div>Luminizer - Powered by <a href="https://www.luminext.eu" target="_blank">Luminext</a></div>
</div>
